import React, {useContext} from "react";
import PurchaseOrderDetail from "../PurchaseOrderDetail/PurchaseOrderDetail";
import UiContext from "../../../contexts/UiContext";
import {SocketContext} from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import {useLocation, useMatch, useNavigate} from "react-router-dom";

type Props = {};

export const PurchaseOrderDetailWrapper = (props: Props) => {
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const navigate = useNavigate();
    const location = useLocation();
    const match = useMatch("/purchase_orders/:guid")

    return <PurchaseOrderDetail
        setActivityIndicator={uiContext.setActivityIndicator}
        setSidebarComponent={uiContext.setSidebarComponent}
        toggleSidebar={uiContext.toggleSidebar}
        socket={socket}
        notifyFn={uiContext.notifyFn}
        userModel={userModel}
        supplierModel={supplierModel}
        history={navigate}
        location={location}
        match={match}
    />;
};
